"use client"

import facebookLogo from "../../assets/facebook.jpg"
import instagramLogo from "../../assets/instagram.jpg"
import useScrollReveal from "../../hooks/useScrollReveal"
import "./Contacts.css"

const Contacts = ({ language }) => {
  useScrollReveal(".contact-link")
  const content = {
    en: {
      title: "Contact Us",
      subtitle: "Get in touch with Governor Abba Kabir Yusuf",
      message: "Connect with Governor Abba Kabir Yusuf on social media for the latest updates and announcements.",
      facebook: "Follow Governor Yusuf on Facebook",
      instagram: "Follow Governor Yusuf on Instagram",
    },
    ha: {
      title: "Tuntube Mu",
      subtitle: "Tuntubi Gwamna Abba Kabir Yusuf",
      message: "Haɗu da Gwamna Abba Kabir Yusuf akan kafofin watsa labarai don sabbin labarai da sanarwar.",
      facebook: "Bi Gwamna Yusuf akan Facebook",
      instagram: "Bi Gwamna Yusuf akan Instagram",
    },
  }

  const current = content[language]

  return (
    <div className="contacts">
      <div className="contacts-header">
        <h1>{current.title}</h1>
        <p>{current.subtitle}</p>
      </div>

      <div className="contacts-message">
        <p>{current.message}</p>
      </div>

      <div className="contacts-container">
        <div className="contacts-grid">
          <a
            href="https://www.facebook.com/EngrAbbaKYusif/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link scroll-reveal"
          >
            <div className="contact-link-circle">
              <img src={facebookLogo} alt="Facebook" className="contact-icon" />
            </div>
            <span className="contact-label">Facebook</span>
          </a>

          <a
            href="https://www.instagram.com/abba_kabir_yusuf/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link scroll-reveal"
          >
            <div className="contact-link-circle">
              <img src={instagramLogo} alt="Instagram" className="contact-icon" />
            </div>
            <span className="contact-label">Instagram</span>
          </a>
        </div>
      </div>
    </div>
  )
}

export default Contacts